<template>
  <v-row v-if="video">
    <v-col style="height: 575px" class="col overflow-y-auto">
      <video-card
        v-for="v in videos"
        :key="v.id"
        :video="v"
        :router-link-to="{name: 'video', params: { id: v.id, video: v }}"
        layout="horizontal"
        :active="v.id === video.id"
      ></video-card>
    </v-col>
  </v-row>
</template>

<script>
import VideoCard from "./videoCard";
import Api from "@/core/services/api.service";

export default {
  name: "videosFromKeywords",
  components: { VideoCard },
  data: () => ({
    videos: [],
    nextVideo: null,
    show: false,
  }),
  props: {
    video: Object,
  },
  computed: {
    apiUrl() {
      return process.env.VUE_APP_API;
    },
  },
  methods: {
    getVideosFromKeywords() {
      const searchWords = this.video.keywords.map((k) => k.name);
      let params = {};
      if (searchWords.length > 0 && searchWords[0] !== "") {
        params["keywords.name"] = searchWords.map(w => w.toLowerCase());
      }

      Api.query("videos", { params: params }).then((videos) => {
        this.videos = videos.data["hydra:member"]
            .filter((v) => v.isVisible)
            .sort((v1, v2) => {
              const v1Keywords = v1.keywords.reduce(
                  (nbKeywords, k) =>
                      nbKeywords + (searchWords.includes(k.name.toLowerCase()) ? 1 : 0),
                  0
              );
              const v2Keywords = v2.keywords.reduce(
                  (nbKeywords, k) =>
                      nbKeywords + (searchWords.includes(k.name.toLowerCase()) ? 1 : 0),
                  0
              );
              return v2Keywords - v1Keywords;
            });

        // Vérification si des vidéos trouvés
        if(this.videos.length > 0){
          let nextVideoIdx = 0;
          let currentVideoIdx = this.videos.findIndex(v => v.id == this.video.id);
          if(currentVideoIdx >= 0 && currentVideoIdx + 1 < this.videos.length){
              nextVideoIdx = currentVideoIdx+1;
          }
          this.nextVideo = this.videos[nextVideoIdx];
          this.nextVideo.route = {name: 'video', params: { id: this.nextVideo.id, video: this.nextVideo }};
          this.$emit("nextVideoDetected",this.nextVideo);
        }
      });
    },
  },
  mounted() {
    this.getVideosFromKeywords();
  }
};
</script>
